import ParkResults from './ParkResults';

export default ParkResults;
